<template>
  <div class="home" v-loading="loading">
    <swiper id="swiperBox" v-bind:options="swiperOption" ref="mySwiper">
      <!-- 首屏品牌 -->
      <swiper-slide class="swiper-slide slide-one">
        <div class="hero-mask"></div>
        <div class="hero-content">
          <p class="hero-eyebrow">湖南中云图地理信息科技有限公司</p>
          <h1 class="hero-brand">中云图</h1>
          <p class="hero-en">ZHONG YUN TU GEOINFO</p>
          <p class="hero-slogan">不忘初心 · 行稳致远</p>
          <p class="hero-desc">无人机航测遥感 · 三维地理信息 · 行业解决方案</p>
          <div class="hero-actions">
            <router-link class="btn btn-primary" to="/goin">走进中云图</router-link>
            <router-link class="btn btn-ghost" to="/case">查看案例</router-link>
          </div>
        </div>
        <div class="scroll-hint">
          <span>向下滚动</span>
          <i class="el-icon-arrow-down"></i>
        </div>
      </swiper-slide>

      <!-- 经典案例 -->
      <swiper-slide class="swiper-slide slide-two">
        <div class="section-mask"></div>
        <div class="section-inner">
          <div class="page">
            <h3>经典案例</h3>
            <p>Successful Cases</p>
          </div>
          <ul class="case-item">
            <li
              v-for="(item,index) in displayCases"
              :key="index"
              v-lazy:background-image="$img(item.Img)"
            >
              <router-link
                class="text-decoration"
                :to="{ name: 'casedetails', params: { id: item.Id }}"
              >
                <div class="case-item-hover">
                  <p class="hover-title">{{item.Title}}</p>
                  <div class="bottom"></div>
                  <div class="more">
                    <span>了解更多</span>
                  </div>
                </div>
              </router-link>
            </li>
          </ul>
          <router-link class="section-more" to="/case">查看全部案例 →</router-link>
        </div>
      </swiper-slide>

      <!-- 最新资讯 -->
      <swiper-slide class="swiper-slide slide-three">
        <div class="section-mask"></div>
        <div class="section-inner">
          <div class="page">
            <h3>最新资讯</h3>
            <p>Latest News</p>
          </div>
          <div class="news-content">
            <div class="news-content-item" v-for="(news,i) in displayNews" :key="i">
              <div :style="'order: '+ (i%2==0 ? 1: 3)">
                <router-link
                  class="text-decoration"
                  :to="{ name: 'newsdetails', params: { id: news.Id }}"
                >
                  <div class="item-img" v-lazy:background-image="$img(news.Img)"></div>
                </router-link>
              </div>
              <div class="news-divider" style="order: 2">
                <span class="dot"></span>
              </div>
              <div class="item-content" :style="'order: '+ (i%2==0 ? 3: 1)">
                <h3>{{news.Title}}</h3>
                <p>{{news.Content}}</p>
                <span>{{formatDate(news.CreateTime)}}</span>
              </div>
            </div>
          </div>
          <router-link class="section-more" to="/news">更多资讯 →</router-link>
        </div>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  name: "Home",
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      loading: true,
      caseList: [],
      newsList: [],
      swiperOption: {
        notNextTick: true,
        direction: "vertical",
        grabCursor: true,
        setWrapperSize: true,
        autoHeight: true,
        slidesPerView: 1,
        mousewheel: true,
        mousewheelControl: true,
        height: window.innerHeight - 60,
        resistanceRatio: 0,
        observeParents: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        }
      }
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper && this.$refs.mySwiper.swiper;
    },
    displayCases() {
      return (this.caseList || []).slice(0, 6);
    },
    displayNews() {
      return (this.newsList || []).slice(0, 3);
    }
  },
  mounted() {
    this.updateSwiperHeight();
    window.addEventListener("resize", this.updateSwiperHeight);
    this.$http
      .all([this.$http.get("Case"), this.$http.get("News")])
      .then(
        this.$http.spread((responseCases, responseNews) => {
          this.caseList = responseCases.data || [];
          this.newsList = responseNews.data || [];
          this.loading = false;
        })
      )
      .catch(() => {
        this.loading = false;
      });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateSwiperHeight);
  },
  methods: {
    updateSwiperHeight() {
      const headerH = window.innerWidth <= 960 ? 56 : 60;
      const nextHeight = Math.max(window.innerHeight - headerH, 480);
      this.swiperOption.height = nextHeight;
      this.$nextTick(() => {
        if (this.swiper) {
          this.swiper.params.height = nextHeight;
          this.swiper.update();
        }
      });
    },
    formatDate(value) {
      if (!value) return "";
      const t = new Date(value);
      if (Number.isNaN(t.getTime())) return value;
      const m = `${t.getMonth() + 1}`.padStart(2, "0");
      const d = `${t.getDate()}`.padStart(2, "0");
      return `${t.getFullYear()}-${m}-${d}`;
    }
  }
};
</script>

<style lang="scss" scoped>
.home {
  position: relative;
  overflow: hidden;
}

.swiper-slide {
  position: relative;
  font-size: 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.hero-mask,
.section-mask {
  position: absolute;
  inset: 0;
  pointer-events: none;
}

.hero-mask {
  background:
    linear-gradient(120deg, rgba(10, 36, 58, 0.72) 0%, rgba(15, 47, 74, 0.45) 48%, rgba(20, 103, 159, 0.35) 100%),
    radial-gradient(circle at 75% 20%, rgba(58, 160, 216, 0.28), transparent 42%);
}

.section-mask {
  background: linear-gradient(180deg, rgba(8, 28, 46, 0.55) 0%, rgba(15, 47, 74, 0.42) 100%);
}

.hero-content {
  position: relative;
  z-index: 2;
  text-align: center;
  color: #fff;
  animation: heroIn 0.9s ease both;
}

.hero-eyebrow {
  margin: 0;
  font-size: 14px;
  letter-spacing: 4px;
  color: rgba(255, 255, 255, 0.82);
}

.hero-brand {
  margin: 14px 0 6px;
  font-size: 72px;
  line-height: 1;
  font-weight: 700;
  letter-spacing: 8px;
  text-shadow: 0 8px 30px rgba(0, 0, 0, 0.25);
}

.hero-en {
  margin: 0;
  font-size: 13px;
  letter-spacing: 5px;
  color: rgba(210, 232, 246, 0.9);
}

.hero-slogan {
  margin: 28px 0 10px;
  font-size: 28px;
  font-weight: 400;
  letter-spacing: 6px;
}

.hero-desc {
  margin: 0;
  font-size: 15px;
  color: rgba(255, 255, 255, 0.86);
  letter-spacing: 2px;
}

.hero-actions {
  margin-top: 34px;
  display: flex;
  justify-content: center;
  gap: 14px;
}

.btn {
  min-width: 128px;
  padding: 10px 22px;
  border-radius: 999px;
  text-decoration: none;
  font-size: 14px;
  transition: transform 0.25s ease, background 0.25s ease, color 0.25s ease;
}

.btn:hover {
  transform: translateY(-2px);
}

.btn-primary {
  background: #3aa0d8;
  color: #fff;
}

.btn-ghost {
  border: 1px solid rgba(255, 255, 255, 0.75);
  color: #fff;
  background: rgba(255, 255, 255, 0.08);
}

.scroll-hint {
  position: absolute;
  left: 50%;
  bottom: 28px;
  transform: translateX(-50%);
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: rgba(255, 255, 255, 0.8);
  font-size: 12px;
  letter-spacing: 2px;
  animation: floatY 1.6s ease-in-out infinite;

  i {
    margin-top: 6px;
    font-size: 16px;
  }
}

.section-inner {
  position: relative;
  z-index: 2;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.page {
  text-align: center;
  overflow: hidden;

  h3 {
    margin: 0;
    font-size: 36px;
    font-weight: 500;
    color: #fff;
    letter-spacing: 4px;
  }

  p {
    margin: 8px 0 0;
    font-size: 13px;
    letter-spacing: 3px;
    color: rgba(210, 232, 246, 0.9);
  }
}

.section-more {
  margin-top: 24px;
  color: #d4edff;
  text-decoration: none;
  font-size: 14px;
  letter-spacing: 1px;
  transition: color 0.2s ease;

  &:hover {
    color: #fff;
  }
}

.case-item {
  width: 1100px;
  max-width: calc(100% - 40px);
  margin: 28px auto 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;

  li {
    width: 340px;
    height: 220px;
    list-style: none;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    position: relative;
    overflow: hidden;
    border-radius: 10px;
    box-shadow: 0 10px 28px rgba(0, 0, 0, 0.22);
    transition: transform 0.35s ease;

    &:hover {
      transform: translateY(-4px);

      .case-item-hover {
        opacity: 1;
      }
    }
  }
}

.case-item-hover {
  width: 100%;
  height: 100%;
  position: absolute;
  inset: 0;
  opacity: 0;
  overflow: hidden;
  background: linear-gradient(180deg, rgba(15, 47, 74, 0.2) 0%, rgba(20, 103, 159, 0.82) 100%);
  transition: opacity 0.35s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .hover-title {
    max-width: 86%;
    color: #fff;
    font-size: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: 500;
    margin: 0;
  }

  .bottom {
    border-bottom: 1px solid rgba(255, 255, 255, 0.85);
    width: 48px;
    margin: 14px auto 0;
  }

  .more {
    margin-top: 22px;
    padding: 6px 16px;
    border: 1px solid rgba(255, 255, 255, 0.9);
    border-radius: 999px;

    span {
      color: #fff;
      font-size: 13px;
      letter-spacing: 1px;
    }
  }
}

.slide-one {
  background: url(../assets/img/home_top.jpg) no-repeat center;
  background-size: cover;
}

.slide-two {
  background: url(../assets/img/home_do.jpg) no-repeat center;
  background-size: cover;
}

.slide-three {
  background: url(../assets/img/home_anli.jpg) no-repeat center;
  background-size: cover;
}

.news-content {
  width: 1200px;
  max-width: calc(100% - 40px);
  margin: 36px auto 0;
  display: flex;
  justify-content: center;
  gap: 18px;

  &-item {
    width: 380px;
    display: flex;
    flex-direction: column;

    .item-img {
      width: 100%;
      height: 210px;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      border-radius: 10px;
      box-shadow: 0 10px 24px rgba(0, 0, 0, 0.2);
      transition: transform 0.35s ease;
    }

    &:hover .item-img {
      transform: scale(1.02);
    }

    .news-divider {
      height: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;

      &::before {
        content: "";
        position: absolute;
        left: 10%;
        right: 10%;
        height: 1px;
        background: rgba(255, 255, 255, 0.45);
      }

      .dot {
        position: relative;
        z-index: 1;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: #3aa0d8;
        box-shadow: 0 0 0 4px rgba(58, 160, 216, 0.25);
      }
    }

    .item-content {
      width: 100%;
      min-height: 180px;
      padding: 8px 4px 0;

      h3 {
        margin: 0;
        font-size: 20px;
        height: 28px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-weight: 500;
      }

      p {
        font-size: 14px;
        height: 72px;
        overflow: hidden;
        margin: 12px 0;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        white-space: normal !important;
        word-wrap: break-word;
        line-height: 1.7;
        opacity: 0.92;
      }

      span {
        display: block;
        font-size: 13px;
        text-align: end;
        opacity: 0.8;
      }

      h3,
      p,
      span {
        color: #fff;
      }
    }
  }
}

@keyframes heroIn {
  from {
    opacity: 0;
    transform: translateY(18px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes floatY {
  0%,
  100% {
    transform: translate(-50%, 0);
  }
  50% {
    transform: translate(-50%, 6px);
  }
}

@media (max-width: 1100px) {
  .hero-brand {
    font-size: 52px;
    letter-spacing: 4px;
  }

  .hero-slogan {
    font-size: 22px;
    letter-spacing: 3px;
  }

  .case-item li {
    width: calc(50% - 12px);
    max-width: 340px;
    height: 190px;
  }

  .news-content {
    flex-wrap: wrap;
  }

  .news-content-item {
    width: calc(50% - 12px);
    max-width: 380px;
  }
}

@media (max-width: 760px) {
  .hero-content {
    padding: 0 18px;
  }

  .hero-eyebrow {
    font-size: 12px;
    letter-spacing: 2px;
  }

  .hero-brand {
    font-size: 40px;
    letter-spacing: 3px;
  }

  .hero-en {
    font-size: 11px;
    letter-spacing: 2px;
  }

  .hero-slogan {
    margin-top: 18px;
    font-size: 18px;
    letter-spacing: 2px;
  }

  .hero-desc {
    font-size: 13px;
    letter-spacing: 1px;
  }

  .hero-actions {
    flex-direction: column;
    align-items: center;
    gap: 10px;
  }

  .page h3 {
    font-size: 28px;
  }

  .case-item {
    gap: 10px;
  }

  .case-item li {
    width: 100%;
    max-width: 100%;
    height: 180px;
  }

  .news-content-item {
    width: 100%;
    max-width: 100%;
  }

  .scroll-hint {
    bottom: 16px;
  }
}
</style>

<style>
.home .swiper-pagination-bullet {
  width: 8px;
  height: 8px;
  background: rgba(255, 255, 255, 0.45);
  opacity: 1;
}
.home .swiper-pagination-bullet-active {
  background: #3aa0d8;
  box-shadow: 0 0 0 3px rgba(58, 160, 216, 0.25);
}
.home .swiper-container-vertical > .swiper-pagination-bullets {
  right: 22px;
}
</style>
